import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

class CustomBackend {
  constructor(services, options = {}) {
    this.init(services, options);
  }

  init(services, options) {
    this.services = services;
    this.options = options;
  }

  // Bind the read method to the class instance
  read(language, namespace, callback) {
    const loadPath = this.options.loadPath
      .replace("{{lng}}", language)
      .replace("{{ns}}", namespace);

    const url = `${this.options.baseUrl || ""}${loadPath}`;

    fetch(url, {
      method: "GET",
      headers: {
        "api-key": process.env.REACT_APP_TRANSLATIONS_API_KEY,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        callback(null, data);
      })
      .catch((error) => {
        console.error("Loading translations failed:", error);
        callback(error, null);
      });
  }

  create(languages, namespace, key, fallbackValue, options) {
    if (!this.options.addPath) return;

    const url = `${this.options.baseUrl || ""}${this.options.addPath}`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-key": process.env.REACT_APP_TRANSLATIONS_API_KEY,
      },
      body: JSON.stringify({
        language: "en",
        namespace,
        key,
        value: fallbackValue,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        i18n.reloadResources();
      })

      .catch((error) => {
        console.error("Saving missing translation failed:", error);
      });
  }

  // Required method for i18next backend interface
  type = "backend";

  // Required method for i18next backend interface
  static type = "backend";
}

// Initialize i18next with the custom backend
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(CustomBackend)
  .init({
    fallbackLng: "en",
    nonExplicitSupportedLngs: false,
    supportedLngs: ["en", "fr"],
    debug: false,
    saveMissing: true,
    backend: {
      baseUrl: `${process.env.REACT_APP_API_URL}/translations`,
      loadPath: "/{{lng}}/{{ns}}",
      addPath: "/missing",
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
